import { render, staticRenderFns } from "./distribution_debts.vue?vue&type=template&id=561d1a45&"
import script from "./distribution_debts.vue?vue&type=script&lang=js&"
export * from "./distribution_debts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports